import { hasLocalStorage } from "../../../../../js/utils/browser/browser";
import { STORAGE_KEYS } from "../../../../../js/constants";

/**
 * Takes care of storing firstname and lastname of supporter in local storage
 * is getting used on the "Thank you" page to display the supporters name
 */
class SupporterName {
  /**
   * @param {Array} elements - input elements
   */
  constructor(elements) {
    this.elements = elements;

    this._onChange = this._onChange.bind(this);

    // check for input values and store them initially
    this._onChange();
    this._bind();
  }

  /**
   * binds event listener
   *
   * @private
   */
  _bind() {
    this.elements.forEach((element) => {
      element.addEventListener("change", this._onChange);
    });
  }

  /**
   * handles user input
   *
   * @private
   */
  _onChange() {
    const name = this.elements
      .reduce((prev, cur) => `${prev.value} ${cur.value}`)
      .trim();

    if (name) {
      SupporterName._writeNameToLocalStorage(name);
    }
  }

  /**
   * writes supporter name to local storage
   *
   * @param {string} name - supporter name
   * @private
   */
  static _writeNameToLocalStorage(name) {
    if (hasLocalStorage()) {
      window.localStorage.setItem(STORAGE_KEYS.SUPPORTER_NAME, name);
    }
  }
}

export default SupporterName;
